import React from 'react';
import {Flex, VStack, Skeleton, Box} from '@tempo/core';
import SectionRowSkeleton from '@components/PageElements/SectionRowSkeleton';

type AnalyticSkeletonProps = {
	variant?: 'analytic' | 'overview';
	'data-testid'?: string;
	'data-state'?: string;
};

const AnalyticSkeleton = ({
	variant = 'analytic',
	...dataAttributes
}: AnalyticSkeletonProps) => {
	if (variant === 'overview') {
		return (
			<Flex
				as="section"
				flexDirection="column"
				width="100%"
				{...dataAttributes}
			>
				<SectionRowSkeleton />

				<VStack
					flex={1}
					spacing="spacing.s"
					alignItems="initial"
					p="spacing.xl"
				>
					<Skeleton height={{base: '20px', md: '24px'}} width="70%" />
					<Skeleton height={{base: '20px', md: '24px'}} width="90%" />
					<Skeleton height={{base: '20px', md: '24px'}} width="80%" />
					<Skeleton height={{base: '20px', md: '24px'}} width="60%" />
				</VStack>
			</Flex>
		);
	}

	return (
		<Flex
			as="section"
			flexDirection="column"
			py={{base: 'spacing.l', md: 'spacing.xl'}}
			px={{base: 'spacing.l', md: 'spacing.3xl'}}
			width="100%"
			{...dataAttributes}
		>
			<VStack spacing={3} alignItems="initial" mb={4}>
				<Skeleton height="24px" width="60%" />
				<Skeleton height="16px" width="40%" />
			</VStack>
			<Box flex={1}>
				<Skeleton height="300px" />
			</Box>
		</Flex>
	);
};

export default AnalyticSkeleton;
